import escape from 'lodash/escape'

import { Fragment } from 'common/components/topics/interfaces'
import { replaceNewLineEmojiAsLineBreak } from 'common/variantsUtils'

import styles from './string.module.css'

const colors = ['bg-maroon-200', 'bg-amber-200', 'bg-green-200', 'bg-blue-200']

export const capitalizeFirstLetter = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function highlightTextFragments(
  controlText: string,
  fragments?: Fragment[]
): string {
  if (!fragments) {
    return controlText
  }
  // Prevent angular brackets from being interpreted as HTML tags
  let enhancedText = escape(controlText)

  if (fragments.length > 0) {
    fragments.forEach(({ name }, index) => {
      if (name) {
        const colorClass = colors[index % colors.length]
        const highlightedText = replaceNewLineEmojiAsLineBreak(name)

        // Escape special regex characters
        const escapedName = name.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')

        enhancedText = enhancedText.replace(
          new RegExp(escapedName, 'g'),
          `<span class="${colorClass} ${styles.highlight}">${highlightedText}</span>`
        )
      }
    })
  } else {
    enhancedText = replaceNewLineEmojiAsLineBreak(enhancedText)
  }

  return `<p class="${styles.sentence}">${enhancedText}</p>`
}

export function containsRtlChars(text: string | undefined): boolean {
  const rtlScriptRegex =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u0590-\u05FF]/
  return text ? rtlScriptRegex.test(text) : false
}
